import React, { useRef } from 'react'
import PrimaryButton from '../../../materialCommitment/buttons/PrimaryButton'
import { PDFDownloadLink } from "@react-pdf/renderer"
import { isMaterialOrGD } from '../../../materialCommitment/helpers/Categories'
import ReportsDocument from '../../../printable/ReportsDocument'
import SecondaryButton from '../../../materialCommitment/buttons/SecondaryButton'


const BottomActionContainer = ({ commitment, startingDate, endingDate, agreeTerms,
    setAgreeTerms, checkAndSendAllReports, reportsReady }) => {
    if (!isMaterialOrGD(commitment.commitmentType) || !startingDate || !endingDate) return null
    const downloadPdfLinkRef = useRef(null);

    /**
     * If user wants to download pdf AND publish, first execute report input validation(s) and if they pass (save the report(s)) download the report pdf.
     */
    const handlePdfDownloadAndPublish = () => {
        if(!checkAndSendAllReports("approved")) return;
        if (downloadPdfLinkRef.current) {
            downloadPdfLinkRef.current.click();
        }
    };

    return(
        <div>
            <div className="flex-row items-center">
                <input
                    type="checkbox"
                    className="input-radio"
                    onChange={(e) => setAgreeTerms(e.target.checked)}
                />
                <p className="p">Olen täyttänyt raportit jokaisen toimenpiteen osalta</p>
            </div>

            

            <div className="flex-row space-between items-center">
                <PrimaryButton
                    textKey={"sit.reporting.publish"}
                    action={() => checkAndSendAllReports("approved")}
                    disabled={!agreeTerms}
                />

                <SecondaryButton
                    textKey={"sit.commitmentCreation.saveDraft"}
                    action={() => checkAndSendAllReports("draft")}
                    
                />

                <PrimaryButton
                    textKey={"sit.reporting.publishAndDownload"}
                    action={() => handlePdfDownloadAndPublish()}
                    disabled={!agreeTerms}
                />

                <PDFDownloadLink
                    style={{ display: "none" }}
                    document={
                        <ReportsDocument
                            commitment={commitment}
                            startingDate={startingDate}
                            endingDate={endingDate}
                            author={commitment.organizationName}
                            operations={reportsReady}
                        />}
                    fileName="raportti.pdf"
                >
                    {({ blob, url, loading, error }) => <button ref={downloadPdfLinkRef} />}
                </PDFDownloadLink>

            </div>
        </div>
    )
}

export default BottomActionContainer


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/BottomActionContainer.jsx